<script setup>
import Header from '@features/shared/ui/Header.global.vue';
import Footer from '@features/shared/ui/Footer.global.vue';
</script>

<template>
  <div class="min-h-screen flex flex-col bg-slate-50 dark:bg-slate-950">
    <Header />
    <main class="flex-1">
      <slot />
    </main>
    <Footer />
  </div>
</template>
